(() => {
if(customElements.get('ss-delivery'))return;
const addBusinessDays=(start,days)=>{const date=new Date(start);date.setHours(12,0,0,0);while(days>0){date.setDate(date.getDate()+1);if(date.getDay()!==0&&date.getDay()!==6)days--;}return date;};
class DeliveryEstimate extends HTMLElement{
connectedCallback(){
this.refresh=()=>{
const d=this.dataset;const num=(key,fallback)=>{const n=Number(d[key]);return d[key]!==undefined&&d[key]!==''&&Number.isFinite(n)&&n>=0?Math.floor(n):fallback;};
const local=d.country==='US';
const min=num('productionMin',0)+num(local?'localMin':'internationalMin',local?2:10);
const max=Math.max(min,num('productionMax',2)+num(local?'localMax':'internationalMax',local?5:30));
const today=new Date();const from=addBusinessDays(today,min),to=addBusinessDays(today,max);
const format=new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',...(from.getFullYear()!==today.getFullYear()||to.getFullYear()!==today.getFullYear()?{year:'numeric'}:{})});
this.querySelector('[data-delivery-dates]').textContent=format.format(from)+' – '+format.format(to);this.hidden=false;
};
this.refresh();this.timer=setInterval(this.refresh,60000);
}
disconnectedCallback(){clearInterval(this.timer);}
}
customElements.define('ss-delivery',DeliveryEstimate);
})();